module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Suits_S8.45336e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Suits_S8.jpg
// module id = 8vAO
// module chunks = 0